module.exports = __webpack_public_path__ + "img/0ab8aacf12cbea669b2ecee2bc5a4836.99427b5c.png";